import { AdminHeaderActionButton } from '@/components/patterns/admin-page'
import { useStripeConnectStatus } from '@/lib/services/stripe-connect/stripe-connect.query'
import { ExternalLink } from 'lucide-react'

export default function StripeConnectDashboardButton({ accountContext = 'current' }) {
  const { data: stripeConnectStatus } = useStripeConnectStatus({ accountContext })

  if (!stripeConnectStatus?.has_full_stripe_dashboard) {
    return null
  }

  return (
    <AdminHeaderActionButton asChild variant="outline">
      <a href="https://dashboard.stripe.com" target="_blank" rel="noreferrer">
        <ExternalLink className="size-4" />
        Stripe Dashboard
      </a>
    </AdminHeaderActionButton>
  )
}
